'use strict';

var _awaitAsyncGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");
var _wrapAsyncGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
var errCode = require('err-code');
var CID = require('cids');

/**
 * @typedef {Object} Pinnable
 * @property {string | InstanceType<typeof window.String> | CID} [path]
 * @property {CID} [cid]
 * @property {boolean} [recursive]
 * @property {any} [metadata]
 *
 * @typedef {CID|string|InstanceType<typeof window.String>|Pinnable} ToPin
 * @typedef {ToPin|Iterable<ToPin>|AsyncIterable<ToPin>} Source
 *
 * @typedef {Object} Pin
 * @property {string|CID} path
 * @property {boolean} recursive
 * @property {any} [metadata]
 */

/**
 * Transform one of:
 *
 * ```ts
 * CID
 * String
 * { cid: CID recursive, metadata }
 * { path: String recursive, metadata }
 * Iterable<CID>
 * Iterable<String>
 * Iterable<{ cid: CID recursive, metadata }>
 * Iterable<{ path: String recursive, metadata }>
 * AsyncIterable<CID>
 * AsyncIterable<String>
 * AsyncIterable<{ cid: CID recursive, metadata }>
 * AsyncIterable<{ path: String recursive, metadata }>
 * ```
 * Into:
 *
 * ```ts
 * AsyncIterable<{ path: CID|String, recursive:boolean, metadata }>
 * ```
 *
 * @param {Source} input
 * @returns {AsyncIterable<Pin>}
 */
// eslint-disable-next-line complexity
module.exports = /*#__PURE__*/function () {
  var _normaliseInput = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(input) {
    var iterator, first, _iterator3, _step3, cid, _iterator4, _step4, obj, _iterator5, _first, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _cid, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _obj;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(input === null || input === undefined)) {
            _context.next = 2;
            break;
          }
          throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');
        case 2:
          if (!CID.isCID(input)) {
            _context.next = 6;
            break;
          }
          _context.next = 5;
          return toPin({
            cid: input
          });
        case 5:
          return _context.abrupt("return");
        case 6:
          if (!(input instanceof String || typeof input === 'string')) {
            _context.next = 10;
            break;
          }
          _context.next = 9;
          return toPin({
            path: input
          });
        case 9:
          return _context.abrupt("return");
        case 10:
          if (!(input.cid != null || input.path != null)) {
            _context.next = 14;
            break;
          }
          _context.next = 13;
          return toPin(input);
        case 13:
          return _context.abrupt("return", _context.sent);
        case 14:
          if (!(Symbol.iterator in input)) {
            _context.next = 62;
            break;
          }
          // @ts-ignore
          iterator = input[Symbol.iterator]();
          first = iterator.next();
          if (!first.done) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return", iterator);
        case 19:
          if (!(CID.isCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
            _context.next = 40;
            break;
          }
          _context.next = 22;
          return toPin({
            cid: first.value
          });
        case 22:
          _iterator3 = _createForOfIteratorHelper(iterator);
          _context.prev = 23;
          _iterator3.s();
        case 25:
          if ((_step3 = _iterator3.n()).done) {
            _context.next = 31;
            break;
          }
          cid = _step3.value;
          _context.next = 29;
          return toPin({
            cid: cid
          });
        case 29:
          _context.next = 25;
          break;
        case 31:
          _context.next = 36;
          break;
        case 33:
          _context.prev = 33;
          _context.t0 = _context["catch"](23);
          _iterator3.e(_context.t0);
        case 36:
          _context.prev = 36;
          _iterator3.f();
          return _context.finish(36);
        case 39:
          return _context.abrupt("return");
        case 40:
          if (!(first.value.cid != null || first.value.path != null)) {
            _context.next = 61;
            break;
          }
          _context.next = 43;
          return toPin(first.value);
        case 43:
          _iterator4 = _createForOfIteratorHelper(iterator);
          _context.prev = 44;
          _iterator4.s();
        case 46:
          if ((_step4 = _iterator4.n()).done) {
            _context.next = 52;
            break;
          }
          obj = _step4.value;
          _context.next = 50;
          return toPin(obj);
        case 50:
          _context.next = 46;
          break;
        case 52:
          _context.next = 57;
          break;
        case 54:
          _context.prev = 54;
          _context.t1 = _context["catch"](44);
          _iterator4.e(_context.t1);
        case 57:
          _context.prev = 57;
          _iterator4.f();
          return _context.finish(57);
        case 60:
          return _context.abrupt("return");
        case 61:
          throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');
        case 62:
          if (!(Symbol.asyncIterator in input)) {
            _context.next = 136;
            break;
          }
          // @ts-ignore
          _iterator5 = input[Symbol.asyncIterator]();
          _context.next = 66;
          return _awaitAsyncGenerator(_iterator5.next());
        case 66:
          _first = _context.sent;
          if (!_first.done) {
            _context.next = 69;
            break;
          }
          return _context.abrupt("return", _iterator5);
        case 69:
          if (!(CID.isCID(_first.value) || _first.value instanceof String || typeof _first.value === 'string')) {
            _context.next = 102;
            break;
          }
          _context.next = 72;
          return toPin({
            cid: _first.value
          });
        case 72:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 74;
          _iterator = _asyncIterator(_iterator5);
        case 76:
          _context.next = 78;
          return _awaitAsyncGenerator(_iterator.next());
        case 78:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 85;
            break;
          }
          _cid = _step.value;
          _context.next = 82;
          return toPin({
            cid: _cid
          });
        case 82:
          _iteratorAbruptCompletion = false;
          _context.next = 76;
          break;
        case 85:
          _context.next = 91;
          break;
        case 87:
          _context.prev = 87;
          _context.t2 = _context["catch"](74);
          _didIteratorError = true;
          _iteratorError = _context.t2;
        case 91:
          _context.prev = 91;
          _context.prev = 92;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 96;
            break;
          }
          _context.next = 96;
          return _awaitAsyncGenerator(_iterator.return());
        case 96:
          _context.prev = 96;
          if (!_didIteratorError) {
            _context.next = 99;
            break;
          }
          throw _iteratorError;
        case 99:
          return _context.finish(96);
        case 100:
          return _context.finish(91);
        case 101:
          return _context.abrupt("return");
        case 102:
          if (!(_first.value.cid != null || _first.value.path != null)) {
            _context.next = 135;
            break;
          }
          _context.next = 105;
          return toPin(_first.value);
        case 105:
          _iteratorAbruptCompletion2 = false;
          _didIteratorError2 = false;
          _context.prev = 107;
          _iterator2 = _asyncIterator(_iterator5);
        case 109:
          _context.next = 111;
          return _awaitAsyncGenerator(_iterator2.next());
        case 111:
          if (!(_iteratorAbruptCompletion2 = !(_step2 = _context.sent).done)) {
            _context.next = 118;
            break;
          }
          _obj = _step2.value;
          _context.next = 115;
          return toPin(_obj);
        case 115:
          _iteratorAbruptCompletion2 = false;
          _context.next = 109;
          break;
        case 118:
          _context.next = 124;
          break;
        case 120:
          _context.prev = 120;
          _context.t3 = _context["catch"](107);
          _didIteratorError2 = true;
          _iteratorError2 = _context.t3;
        case 124:
          _context.prev = 124;
          _context.prev = 125;
          if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
            _context.next = 129;
            break;
          }
          _context.next = 129;
          return _awaitAsyncGenerator(_iterator2.return());
        case 129:
          _context.prev = 129;
          if (!_didIteratorError2) {
            _context.next = 132;
            break;
          }
          throw _iteratorError2;
        case 132:
          return _context.finish(129);
        case 133:
          return _context.finish(124);
        case 134:
          return _context.abrupt("return");
        case 135:
          throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');
        case 136:
          throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');
        case 137:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[23, 33, 36, 39], [44, 54, 57, 60], [74, 87, 91, 101], [92,, 96, 100], [107, 120, 124, 134], [125,, 129, 133]]);
  }));
  function normaliseInput(_x) {
    return _normaliseInput.apply(this, arguments);
  }
  return normaliseInput;
}();

/**
 * @param {Pinnable} input
 */
function toPin(input) {
  var path = input.cid || "".concat(input.path);
  if (!path) {
    throw errCode(new Error('Unexpected input: Please path either a CID or an IPFS path'), 'ERR_UNEXPECTED_INPUT');
  }

  /** @type {Pin} */
  var pin = {
    path: path,
    recursive: input.recursive !== false
  };
  if (input.metadata != null) {
    pin.metadata = input.metadata;
  }
  return pin;
}